import { render, staticRenderFns } from "./Chapter.vue?vue&type=template&id=63a0b65c&scoped=true&"
import script from "./Chapter.vue?vue&type=script&lang=js&"
export * from "./Chapter.vue?vue&type=script&lang=js&"
import style0 from "./Chapter.vue?vue&type=style&index=0&id=63a0b65c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a0b65c",
  null
  
)

export default component.exports